import { t } from 'i18next';
import React from 'react';
import { Helmet } from 'react-helmet';

export default function Refund() {
  return (
    <>
      <Helmet>
        <title>Refund Policy</title>
      </Helmet>
      <div className="max-w-2xl mx-auto mt-5 top-0 px-6 lg:px-0">
        <div className="bg-white rounded-3xl p-5 md:p-10 shadow-md shadow-black/5">
          <div className="max-w-sm mx-auto">
            <h2 className="font-semibold text-xl text-center mb-5">
              {/* {t('termsAndConditions')} */}
              Refund Policy
            </h2>
          </div>
          <article className="prose prose-sm prose-h3:text-gray-600 ">
            <h4>Refund Policy - Consultation and Workshop Services</h4>
            <p>
              This Refund Policy outlines the terms and conditions for
              requesting refunds related to Emstell Kuwait Team's (referred to
              as "we," "us," or "our") consultation and workshop services.
            </p>
            <h4>Consultation Refunds:</h4>

            <p>
              Cancellation: A refund for consultation services will be provided
              if the cancellation request is received at least 24 hours before
              the scheduled first session.
            </p>
            <p>
              Refund Amount: Refunds for cancelled consultation services will be
              processed, excluding any payment gateway charges and a service fee
              of 10% of the total paid amount.
            </p>

            <p>
              No Refunds After First Session: Once the first session of the
              consultation has taken place, no refunds will be issued for any
              reason.
            </p>
            <h4>Workshop Refunds:</h4>
            <p>
              Cancellation: A refund for workshop registration will be provided
              if the cancellation request is received at least 24 hours before
              the scheduled start of the workshop.
            </p>
            <p>
              Refund Amount: Refunds for canceled workshop registrations will be
              processed, excluding any payment gateway charges and a service fee
              of 10% of the total paid amount.
            </p>
            <p>
              No Refunds After Workshop Start: Once the workshop has started
              (after the first session), no refunds will be issued for any
              reason.
            </p>
            <h4>Refund Processing:</h4>
            <p>
              Processing Time: Refunds will be processed within two weeks from
              the date of the refund request.
            </p>
            <p>
              Deductions: Refunds will be deducted by the payment gateway
              charges and a service fee equivalent to 10% of the total paid
              amount.
            </p>
            <h4>How to Request a Refund:</h4>
            <p>
              To request a refund for a canceled consultation or workshop
              registration, please contact us at [contact information]. Refund
              requests must be submitted at least 24 hours before the scheduled
              start of the first session.
            </p>
            <h4>Contact Us:</h4>
            <p>
              If you have any questions or concerns about our refund policy,
              please contact us at [contact information].
            </p>
            <p>
              By engaging in our consultation and workshop services, you
              acknowledge that you have read, understood, and agreed to this
              Refund Policy. These terms may be subject to change, and any
              revisions will be communicated to you through our official
              communication channels.
            </p>
            <p>
              Date of Last Update: 08/08/2023 <br /> Best regards, <br />{' '}
              Emstell Kuwait Team
            </p>
          </article>
        </div>
      </div>
    </>
  );
}
